// extracted by mini-css-extract-plugin
export default {"particles":"ParticlesComponent_particles__KNLAo","particlesDark":"ParticlesComponent_particlesDark__sGKJB","particlesLight":"ParticlesComponent_particlesLight__z9+Q5"};